import { Module } from 'vuex';
import { RallyIntelligenceState, RootState } from '../types';
import { getters } from './getters';
import { mutations } from './mutations';

const namespaced: boolean = true;

const INITIAL_CREDITS = 5;

export const state: RallyIntelligenceState = {
	creditsRemaining: INITIAL_CREDITS
};

export const rallyIntelligence: Module<RallyIntelligenceState, RootState> = {
	namespaced,
	state,
	getters,
	mutations
};

export default rallyIntelligence;
